module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('el-card', {
    staticClass: "box-card infobox"
  }, [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("用户名："), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'http://jazpan.com/user/' + _vm.getUserInfo.uid
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getUserInfo.name) + "\n          ")]), _vm._v(" "), (_vm.getUserInfo.tmpname == 1) ? _c('i', {
    staticClass: "el-icon-edit-outline",
    staticStyle: {
      "cursor": "pointer",
      "color": "red",
      "font-weight": "bold"
    },
    attrs: {
      "alt": "可使用密码登录"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.NameForm.show()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("ID：" + _vm._s(_vm.getUserInfo.uid))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("昵称：" + _vm._s(_vm.getUserInfo.nick))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("注册时间：" + _vm._s(_vm.getUserInfo.times))])], 1), _vm._v(" "), (_vm.balances > 0.0 || _vm.balancetx > 0.0) ? _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("余额："), _c('span', {
    staticClass: "amountxs"
  }, [_vm._v(_vm._s(_vm.balances))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("正在提现："), _c('span', {
    staticClass: "amountxs"
  }, [_vm._v(_vm._s(_vm.balancetx))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("VIP1："), _c('span', [_vm._v(_vm._s(_vm.getUserInfo.vip1))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("VIP2："), _c('span', [_vm._v(_vm._s(_vm.getUserInfo.vip2))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_vm._v("\n        简介：" + _vm._s(_vm.getUserInfo.desc) + "\n      ")]), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.proEdit.show()
      }
    }
  }, [_vm._v("修改资料")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.avatEdit.show()
      }
    }
  }, [_vm._v("修改头像")]), _vm._v(" "), (_vm.balances > 0.0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.chongVipDlg.show()
      }
    }
  }, [_vm._v("充值VIP")]) : _vm._e(), _vm._v(" "), (_vm.balances > 0.0) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": _vm.tixianFun
    }
  }, [_vm._v("提现")]) : _vm._e(), _vm._v(" "), (_vm.balances > 0.0) ? _c('el-button', {
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/txs')
      }
    }
  }, [_vm._v("提现记录")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.balances > 0.0),
      expression: "balances > 0.0"
    }],
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('el-card', {
    staticClass: "box-card chartsbox"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "blChart1"
    }
  })]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card chartsbox"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "blChart2"
    }
  })])], 1), _vm._v(" "), _c('NameForm', {
    ref: "NameForm"
  }), _vm._v(" "), _c('proEdit', {
    ref: "proEdit"
  }), _vm._v(" "), _c('avatEdit', {
    ref: "avatEdit"
  }), _vm._v(" "), _c('txEdit', {
    ref: "txEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getBalances()
      }
    }
  }), _vm._v(" "), _c('txTaxEdit', {
    ref: "txTaxEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getBalances()
      }
    }
  }), _vm._v(" "), _c('ChongVip', {
    ref: "chongVipDlg",
    on: {
      "submitOK": function($event) {
        return _vm.refreshPg()
      }
    }
  }), _vm._v(" "), _c('ChongZhi', {
    ref: "chongZhiDlg",
    on: {
      "submitOK": function($event) {
        return _vm.refreshPg()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18ae9bcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 1151
// module chunks = 1